module.exports = __webpack_public_path__ + "media/G7.b04c8172.wav";